import { BASE_URL, WORKSHOP_EVALUATION_QUESTION_DIMENSION } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IWorkshopEvaluationQuestionDimensionInput } from "models/workshopEvaluationQuestionDimension";


export async function getWorkshopEvaluationQuestionDimensions(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOP_EVALUATION_QUESTION_DIMENSION + params);
  return response.data;
}
export async function addWorkshopEvaluationQuestionDimension(data: IWorkshopEvaluationQuestionDimensionInput) {
  const response = await axios.post(BASE_URL + WORKSHOP_EVALUATION_QUESTION_DIMENSION, data);
  return response.data;
}
export async function editWorkshopEvaluationQuestionDimension(data: IWorkshopEvaluationQuestionDimensionInput, id: string) {
  const response = await axios.patch(BASE_URL + WORKSHOP_EVALUATION_QUESTION_DIMENSION + "/" + id, data);
  return response.data;
}

export async function deleteWorkshopEvaluationQuestionDimension(id: string) {
  const response = await axios.delete(BASE_URL + WORKSHOP_EVALUATION_QUESTION_DIMENSION + "/" + id);
  return response.data;
}

export const WorkshopEvaluationQuestionDimensionCells: HeadCell[] = [
  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "T_description",
  },
  {
    id: "descriptionAr",
    numeric: false,
    disablePadding: false,
    label: "T_description_ar",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
